import { ApiContext, Cart } from '../../types'
import { deserializeCart } from '../serializers/cart'
import getCurrentBearerToken from '@/api_client/api/authentication/getCurrentBearerToken'

export default async function removeFromOrder(
  { client, config }: ApiContext,
  orderId,
  lineItemId,
): Promise<Cart> {
  try {
    const token = await getCurrentBearerToken({
      client,
      config,
    })

    const result = await client.cart.removeItem(
      { bearerToken: token },
      orderId,
      lineItemId,
      {},
      // { ...cartParams },
    )

    if (result.isSuccess()) {
      const payload = result.success()
      const cart = deserializeCart(payload.data, payload.included, config)
      return cart
    } else {
      throw result.fail()
    }
  } catch (e) {
    console.error(e)
    throw e
  }
}
